import React from "react";

const ProgressBar = (props) => {
  const { bgcolor, completed } = props;

  const containerStyles = {
    position:'absolute',
    height: 19,
    width: "95%",
    left: '50px',
    top:'3px',
    background: "white",
    borderRadius: '3px 5px 5px 3px',
    border: `2px double white`,
  };
 
  const numberWrap = {
    position: 'relative',
    width: `100%`,
    height: 25,
    padding: '5px',
    color: 'white',
    background: bgcolor,
    borderRadius: '8px'
  }

  const numberStyles = {
    position:'absolute',
    top:'-4px',
    padding: "5px",
    color: "white",
    marginRight: "15px",
    marginBottom: "5px"
  }

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    background: bgcolor,
    transition: "width 1s ease-in-out",
    borderRadius: "0 20px 20px 0",
    transition: "width 0.5s ease-in-out",
    position:'relative'
  };

  const labelStyles = {
    padding: "5px",
    color: "white",
    marginRight: "15px",
    marginBottom: "5px"
  };

  return (
    <div style={{display: completed !== 0 ? 'flex' : 'none', justifyContent:'center', alignItems:'center'}}>
      <div style={numberWrap}>
        <span style={{...numberStyles}}>{`${completed}%` }</span>
        <div style={{...containerStyles}}>
          <div style={{...fillerStyles}}>
            <span style={{...labelStyles,position:'absolute', top:'-8px', right:0}}>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/Course/ProgressBar.js